import { render } from "./MainMenuContent.vue?vue&type=template&id=0e83c4b8&lang=html"
import script from "./MainMenuContent.vue?vue&type=script&lang=js"
export * from "./MainMenuContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__